export const DEFAULT_ZOOM_LEVEL_SHORTCUT_DELTA = 0.45;
export const LAYER_IDS = {
    HIGHLIGHT: 'sys.layer.highlight',
    INFO: 'sys.layer.info',
    INFO_RESULTS: 'sys.layer.info-results',
    MEASURE: 'sys.layer.measure',
    NOTES: 'sys.layer.notes',
    NOTES_MODIFY: 'sys.layer.notes-modify',
    SEARCH: 'sys.layer.search',
    USER_LOCATION: 'sys.layer.user-location',
    EDIT_TOOLS_HIGHLIGHT: 'sys.layer.edit-tools-highlight',
    EDIT_TOOLS_MODIFY: 'sys.layer.edit-tools-modify',
    EDIT_TOOLS_SNAP: 'sys.layer.edit-tools-snap',
    PANORAMA: 'sys.layer.panorama',
};
export const LAYER_TYPE = {
    TILE: 'Tile',
    VECTOR: 'Vector',
    WMTS: 'WMTS',
    TILE_ARCGIS_REST: 'TileArcGISRest',
    TILE_ARCGIS: 'TileArcGIS',
    IMAGE_ARCGIS_REST: 'ImageArcGISRest',
    IMAGE_WMS: 'ImageWMS',
    TILE_VECTOR: 'VectorTile',
    FEATURE_ARCGIS: 'FeatureArcGIS',
};
export var INTERACTION;
(function (INTERACTION) {
    INTERACTION["NONE"] = "NONE";
    INTERACTION["DRAW"] = "DRAW";
    INTERACTION["SELECT"] = "SELECT";
    INTERACTION["MODIFY"] = "MODIFY";
    INTERACTION["SELECT_MODIFY"] = "SELECT_MODIFY";
})(INTERACTION || (INTERACTION = {}));
export const GEOMETRY_LAYOUT = {
    XY: 'XY',
    XYZ: 'XYZ',
    XYM: 'XYM',
    XYZM: 'XYZM',
};
export const COLOR = {
    DEFAULT: [3, 155, 229],
    HIGHLIGHT: [204, 62, 216],
    ACTIVE: [224, 70, 78],
    OUTLINE: [255, 255, 255],
};
export var PANEL;
(function (PANEL) {
    PANEL["NONE"] = "NONE";
    PANEL["LAYER_SWITCHER"] = "LAYER_SWITCHER";
    PANEL["LEGEND"] = "LEGEND";
    PANEL["MEASURE"] = "MEASURE";
    PANEL["SEARCH"] = "SEARCH";
    PANEL["NOTES"] = "NOTES";
})(PANEL || (PANEL = {}));
export var MAP_TOOL;
(function (MAP_TOOL) {
    MAP_TOOL["NONE"] = "NONE";
    MAP_TOOL["INFOEDIT"] = "INFOEDIT";
    MAP_TOOL["INTERSECTION_SPLIT_LINE"] = "INTERSECTION_SPLIT_LINE";
    MAP_TOOL["DELETE"] = "DELETE";
    MAP_TOOL["DRAW"] = "DRAW";
    MAP_TOOL["JOIN_LINE"] = "JOIN_LINE";
    MAP_TOOL["SPLIT_LINE"] = "SPLIT_LINE";
    MAP_TOOL["REVERSE_LINE"] = "REVERSE_LINE";
    MAP_TOOL["MEASURE_LINE"] = "MEASURE_LINE";
    MAP_TOOL["MEASURE_POLYGON"] = "MEASURE_POLYGON";
    MAP_TOOL["NOTE_SELECT"] = "NOTE_SELECT";
    MAP_TOOL["NOTE_DRAW_POINT"] = "NOTE_DRAW_POINT";
    MAP_TOOL["NOTE_DRAW_LINE"] = "NOTE_DRAW_LINE";
    MAP_TOOL["NOTE_DRAW_POLYGON"] = "NOTE_DRAW_POLYGON";
    MAP_TOOL["NOTE_DRAW_TEXT"] = "NOTE_DRAW_TEXT";
    MAP_TOOL["SELECT_FEATURE"] = "SELECT_FEATURE";
})(MAP_TOOL || (MAP_TOOL = {}));
export const NOTE_TOOLS = [
    MAP_TOOL.NOTE_SELECT,
    MAP_TOOL.NOTE_DRAW_LINE,
    MAP_TOOL.NOTE_DRAW_POINT,
    MAP_TOOL.NOTE_DRAW_POLYGON,
    MAP_TOOL.NOTE_DRAW_TEXT,
];
export const MEASURE_TOOLS = [MAP_TOOL.MEASURE_POLYGON, MAP_TOOL.MEASURE_LINE];
export const EDIT_TOOLS = [
    MAP_TOOL.INTERSECTION_SPLIT_LINE,
    MAP_TOOL.DELETE,
    MAP_TOOL.DRAW,
    MAP_TOOL.INFOEDIT,
    MAP_TOOL.JOIN_LINE,
    MAP_TOOL.SPLIT_LINE,
    MAP_TOOL.REVERSE_LINE,
    MAP_TOOL.SELECT_FEATURE,
];
//# sourceMappingURL=constants.js.map